import React, {useEffect, useRef, useState} from 'react';
import './FactionSkinRewardModal.css';
import {getFactionSkinConfig, getFactionSkinImagePath} from '../../../configs/factions/skins/allFactionSkins';
import {COLORS_CONFIG, PLAYER_COLORS} from '../../../configs/colors';
import PageButton from "../../elements/PageButton/PageButton";
import {getFactionConfig} from "../../../utils/factions/getFactionConfig";
import {getFormattedPrice} from "../../../utils/price/getFormattedPrice";
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";
import {getFactionSkinPrice} from "../../../utils/factions/getFactionSkinPrice";
import {FACTION_SKIN_CURRENCIES} from "../../../constants/factions/skins";
import SkinRankMark from "../../SkinRankMark/SkinRankMark";
import {getFactionSkinRank} from "../../../utils/factions/getFactionSkinRank";
import {getFactionSkinAccentColorKey} from "../../../utils/factions/getFactionSkinAccentColorKey";

const PAGE_ID = 'FactionSkinRewardModal';

function FactionSkinRewardModal({skinId, onClaim, onEntered}) {
  const [visible, setVisible] = useState(false);
  const enteredRef = useRef(false);

  const skinConfig = getFactionSkinConfig(skinId);
  const factionConfig = getFactionConfig(skinConfig.factionId);
  const resolveFactionColor = (colorKey, fallbackColor) => {
    if (colorKey === PLAYER_COLORS.BROWN) return '#7b3c00';
    if (colorKey === PLAYER_COLORS.BLUE) return '#157be0';
    return COLORS_CONFIG[colorKey] || fallbackColor;
  };
  const factionColor = resolveFactionColor(
    getFactionSkinAccentColorKey(skinConfig, factionConfig),
    factionConfig.textColor
  );
  const factionName = factionConfig.name;

  useEffect(() => {
    const soundManager = MENU_SOUND_MANAGER;
    if (soundManager?.playFactionSelect && skinConfig?.factionId) {
      soundManager.playFactionSelect(skinConfig.factionId);
    }

    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, [skinConfig]);

  const handleClaim = () => {
    setVisible(false);
    setTimeout(() => {
      onClaim?.();
    }, 300);
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClaim();
    }
  };

  const handleTransitionEnd = (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.propertyName !== 'opacity') return;
    if (visible && !enteredRef.current) {
      enteredRef.current = true;
      onEntered?.();
    }
  };

  if (!skinConfig) return null;

  const originalPrice = getFactionSkinPrice(skinConfig);
  const isCrystalsPrice = originalPrice?.currency === FACTION_SKIN_CURRENCIES.CRYSTALS;

  return (
    <div
      className={`faction-skin-reward-overlay ${visible ? 'faction-skin-reward-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      onTransitionEnd={handleTransitionEnd}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`faction-skin-reward-modal ${visible ? 'faction-skin-reward-modal_visible' : ''}`}
        style={{'--faction-color': factionColor}}
      >
        <div className="faction-skin-reward-content">
          <div className="faction-skin-reward-image-wrapper">
            <img
              className="faction-skin-reward-image"
              src={getFactionSkinImagePath(skinId)}
              alt={skinConfig.name}
            />
            {/* Шевроны рейтинга выпавшего обличия — как на его плитке в
                коллекции и в карусели (см. SkinRankMark) */}
            <SkinRankMark
              skinRank={getFactionSkinRank(skinId, skinConfig.factionId)}
              className="faction-skin-reward-skin-rank"
            />
          </div>
          <div className="faction-skin-reward-info">
            <h2 className="faction-skin-reward-name" style={{color: factionColor}}>
              {skinConfig.name}
            </h2>
            <span
              className="faction-skin-reward-faction"
              style={{color: factionColor}}
            >
              {factionName}
            </span>
            <span className="faction-skin-reward-title">Новый скин фракции!</span>

            {originalPrice && (
              <div className={`faction-skin-reward-original-price ${isCrystalsPrice ? 'text-crystals' : 'text-coins-dark'}`}>
              <span className="faction-skin-reward-original-price-label">
                Оригинальная цена:
              </span>
                <span className="faction-skin-reward-original-price-value">
                {getFormattedPrice(originalPrice.amount)}
              </span>
                <img
                  className="faction-skin-reward-original-price-icon"
                  src={isCrystalsPrice ? '/img/icons/crystal.png' : '/img/icons/numens.png'}
                  alt={isCrystalsPrice ? 'кристаллы' : 'нумены'}
                />
              </div>
            )}
          </div>

          <div className="main-menu-buttons faction-skin-reward-buttons">
            <PageButton onClick={handleClaim} pageId={PAGE_ID} buttonId="claim_reward">
              Принять дар
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FactionSkinRewardModal;
